import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class UtilService {
    constructor(private _httpClient: HttpClient) { }

    getAddressByZipCode(zipCode: string) {
        return this._httpClient.get<any>('http://viacep.com.br/ws/' + zipCode + '/json');
    }
}
